








































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ColorPicker from "@/commonComponents/colorPicker/colorPicker.vue";
import RangeSlider from "@/components/VRangeSliderStyling.vue";

import * as def from "@/definitions";

import { PatternBaseLayer } from "@/model/document2/page/surface/design/layer/patternBaseLayer";
import { ColorConstruct } from "@/utilityModels/colorConstruct";

import ColorSelector from "@/commonComponents/colorSelector/colorSelector.vue";
import AdjustedBalloon from '@/commonComponents/adjustedBalloon/adjustedBalloon.vue';

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import RadioOn from "../resources/radioOn.vue";

import { ResourceHelper } from "@/helper/resourceHelper"

@Component({
  components: {
    ColorPicker,
    RangeSlider,
    ColorSelector,
    AdjustedBalloon,

    ArrowDown,
    ArrowRight,
    RadioOn
  }
})
export default class PatternColorFillSolid extends Vue {
  @Prop()
  private layer!: PatternBaseLayer;

  //↓↓↓↓↓開閉のアニメーション↓↓↓↓↓
  //こいつはpropsでもらいたい
  openStatus = {
    opend: true
  };

  patternColorFillSolidContentsOpenAnimate = false;
  patternColorFillSolidContentsCloseAnimate = false;

  open() {
    if (this.openStatus.opend) {
      this.patternColorFillSolidContentsCloseAnimate = true;
      setTimeout(() => {
        this.patternColorFillSolidContentsCloseAnimate = false;
        this.patternColorFillSolidContentsOpenAnimate = false;
        this.openStatus.opend = false;
      }, 200);
    } else {
      this.openStatus.opend = true;
      this.patternColorFillSolidContentsOpenAnimate = true;
      setTimeout(() => {
        this.patternColorFillSolidContentsOpenAnimate = false;
      }, 250);
    }
  }
  //↑↑↑↑↑開閉のアニメーション↑↑↑↑↑

  //↓↓↓↓↓カラーピッカー表示非表示↓↓↓↓↓
  //こいつはpropsでいらない
  isColorPickerVisible = false;
  showColorPicker() {
    this.isColorPickerVisible = true;
  }
  closeColorPicker() {
    this.isColorPickerVisible = false;
  }
  //↑↑↑↑↑カラーピッカー表示非表示↑↑↑↑↑

  //↓↓↓↓↓色↓↓↓↓↓

  get fillColor(): ColorConstruct {
    //この書き方だとなぜか認識されない
    return this.layer.fillColor;
  }

  get fillColorStyle() {
    return {
      background: this.fillColor.hex
    };
  }

  // 色変更中
  private onChangingColor(color) {
    this.changeLayerProperty(color , "fillColor");
  }
  // 色変更完了
  private onChangedColor(color) {
    this.changeLayerProperty(color, "fillColor");
  }

  //↑↑↑↑↑色↑↑↑↑↑

  //↓↓↓↓↓透明度↓↓↓↓↓
  private get opacity() {
    return this.layer.opacity;
  }
  private get opacitySliderValue() {
    return this.opacity;
  }
  private set opacitySliderValue(value) {
    this.changeLayerProperty(value, "opacity", false);
  }
  private onChangeOpacity(value) {
    this.changeLayerProperty(value, "opacity", true);
  }
  //↑↑↑↑↑透明度↑↑↑↑↑

  private changeFillType(fillType: string) {
    var layerFillType = 0;
    if (fillType == "none") {
      layerFillType = 0;
    } else if (fillType == "solid") {
      layerFillType = 1;
    } else if (fillType == "gradient") {
      layerFillType = 2;
    }

    this.changeLayerProperty(layerFillType , "fillType");
  }

  private changeLayerProperty(value: any, propertyName: string, isFinish : boolean = false, isOnce : boolean = false)
    {
        this.$emit("doCommand", "changeLayerProperty", {
            layer: this.layer,
            propertyName: propertyName,
            value: value,
            isFinish : isFinish,
            isOnce : isOnce
        });
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}
